import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';

import { cloneDeep } from 'lodash-es';

import { ioteqNavigationItem } from '@tools/components/navigation';

import { defaultNavigation, navigationMenu } from 'app/api/common/navigation/data';

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    private _defaultNavigation: ioteqNavigationItem[] = defaultNavigation;

    private readonly _navigationMenu = navigationMenu;

    navigationMenu: any = []

    /**
     * Constructor
     */
    constructor(){

        this.generateNavigation(this.navigationMenu)
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    getNavigation(menu){
        //console.log(menu)

        let customNavigation = []
        menu.forEach((tab) => {
            //console.log(typeof tab)

            if(typeof tab === "object"){

                for (var item in tab){

                    if(typeof tab[item] === "object"){

                        let final_tab_content = {}

                        final_tab_content["id"] = this._navigationMenu[item]["id"]
                        final_tab_content["title"] = this._navigationMenu[item]["title"]
                        final_tab_content["subtitle"] = this._navigationMenu[item]["subtitle"]
                        final_tab_content["type"] = this._navigationMenu[item]["type"]
                        final_tab_content["icon"] = this._navigationMenu[item]["icon"]

                        if(this._navigationMenu[item].hasOwnProperty("children")){

                            final_tab_content["children"] = []

                            for(var i in this._navigationMenu[item]["children"]){

                                for (var ii in tab[item]){
                                    if (tab[item][ii] === this._navigationMenu[item]["children"][i]["id"]){
                                        final_tab_content["children"].push(this._navigationMenu[item]["children"][i])
                                    }
                                }
                            }
                        }
                        customNavigation.push(final_tab_content)

                    }else if(typeof tab[item] === "boolean"){
                        if(tab[item]){
                            customNavigation.push(this._navigationMenu[item])
                        }
                    }
                }
            }else{
                customNavigation.push(this._navigationMenu[tab])
            }
        });

        //console.log(customNavigation)

        let navigation = {
            custom   : cloneDeep(customNavigation)
        }
        this.navigationMenu = navigation

        this.generateNavigation(this.navigationMenu)
    }

    generateNavigation(navigationMenu){
        
        //console.log(navigationMenu)
        this._navigation.next(navigationMenu);
    }
}